import type { OptionallyConditionalItem } from '@lemonade-hq/chat-wizard-common-definitions';
import type { DynamicComponentSection } from './components/dynamic_component_section';
import type { InterpolableTextProps } from './components/interpolable_text';
import type { LabelsSelectableOptionProps } from './components/selectable';
import type { TextObject } from './summary';

export type PaymentSelectableType = LabelsSelectableOptionProps<string | undefined>;
export type PaymentPlan = PaymentSelectableType;

export interface PaymentSelectableProps<
  TComponentAttributes extends string = string,
  TOption extends PaymentSelectableType = PaymentSelectableType,
> {
  readonly title: string;
  readonly options: TOption[];
  readonly attribute: TComponentAttributes;
}

export type PaymentMethod<TComponentAttributes extends string = string> = PaymentSelectableType & {
  readonly attributes: TComponentAttributes[];
  readonly sections: DynamicComponentSection<TComponentAttributes>[];
};

export type PaymentMethodProps<TComponentAttributes extends string = string> = PaymentSelectableProps<
  TComponentAttributes,
  PaymentMethod<TComponentAttributes>
>;

export type PaymentPlanProps<TComponentAttributes extends string = string> = PaymentSelectableProps<
  TComponentAttributes,
  OptionallyConditionalItem<PaymentPlan>
>;

export function paymentMethod<TComponentAttributes extends string>(
  props: Omit<PaymentMethod<TComponentAttributes>, 'presentation'>,
): PaymentMethod<TComponentAttributes> {
  return { ...props, presentation: 'labels' };
}

export type PaymentDisclaimersProps = (OptionallyConditionalItem<InterpolableTextProps | TextObject> | string)[];
